import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import InputCol from './InputCol';
import MandatoryInput from './MandatoryInput';

const FormInputFactory = ({t, formFactory, title, nameInput, formState, onChange, translationValue, show, customText, ...props}) => {
  const {required, initial, type} = formFactory[nameInput];
  if (required) {
    return <MandatoryInput
      title={title ? title : `${t(translationValue ? translationValue : nameInput)} : `}
      name={nameInput}
      key={nameInput}
      type={type}
      onChange={onChange}
      value={formState[nameInput]}
      show={show !== null ? show : formState[nameInput] === initial}
      customText={customText ? customText : null}
      {...props}
    />;
  } else {
    return <InputCol
      key={nameInput}
      title={`${t(translationValue ? translationValue : nameInput)} : `}
      name={nameInput}
      type={type}
      onChange={onChange}
      value={formState[nameInput]}
      {...props}
    />;
  }
};

FormInputFactory.defaultProps = {
  title: null,
  translationValue: '',
  customText: '',
  disabled: false,
  show: null,
};

FormInputFactory.propTypes = {
  t: PropTypes.func.isRequired,
  formFactory: PropTypes.object.isRequired,
  title: PropTypes.string,
  nameInput: PropTypes.string.isRequired,
  formState: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  translationValue: PropTypes.string,
  show: PropTypes.bool,
  customText: PropTypes.string,
  disabled: PropTypes.bool,
};

export default withTranslation('merchant')(FormInputFactory);
